import React from "react"

import {
    QueryClient,
    type QueryClientConfig,
    QueryClientProvider,
} from "@tanstack/react-query"

export const ReactQueryProvider: React.FunctionComponent<{
    config?: QueryClientConfig
    children?: React.ReactNode
}> = props => {
    const queryClient = new QueryClient(props.config)

    return (
        <QueryClientProvider client={queryClient}>
            {props.children}
        </QueryClientProvider>
    )
}
